<template>
  <div class="register-container">
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
        <div style="color: transparent">占位符</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <el-form
          ref="registerForm"
          :model="form"
          class="register-form"
          :rules="registerRules"
          size="mini"
        >
          <el-form-item prop="username">
            <el-input
              v-model.trim="form.username"
              v-focus
              style="margin-top: 20px"
              type="text"
              placeholder="请输入姓名"
              auto-complete="off"
            >
              <zr-icon slot="prefix" icon="user-alt"></zr-icon>
            </el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input
              v-model.trim="form.phone"
              type="text"
              placeholder="请输入手机号"
              maxlength="11"
              show-word-limit
              autocomplete="off"
            >
              <zr-icon slot="prefix" icon="mobile-alt"></zr-icon>
            </el-input>
          </el-form-item>
          <el-form-item prop="email">
            <el-input
              v-model.trim="form.email"
              type="text"
              placeholder="请输入邮箱"
              autocomplete="off"
            >
              <zr-icon slot="prefix" icon="mail-bulk"></zr-icon>
            </el-input>
          </el-form-item>
          <el-form-item prop="idCardNum">
            <el-input
              v-model.trim="form.idCardNum"
              type="text"
              placeholder="请输身份证号码"
              autocomplete="off"
            >
              <zr-icon slot="prefix" icon="id-card"></zr-icon>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model.trim="form.password"
              type="password"
              placeholder="设置密码"
              autocomplete="new-password"
              ><zr-icon slot="prefix" icon="unlock"></zr-icon
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model.trim="form.confirmPassword"
              type="password"
              placeholder="确认密码"
              autocomplete="new-password"
              ><zr-icon slot="prefix" icon="unlock"></zr-icon
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-row>
              <el-col :lg="12" :sm="8" :xs="8">
                <el-button
                  v-loading.fullscreen.lock="fullscreenLoading"
                  class="register-btn"
                  type="primary"
                  @click.native.prevent="handleReister"
                >
                  <zr-icon icon="pencil-alt"></zr-icon> 注册
                </el-button>
              </el-col>
              <el-col :lg="6" :sm="8" :xs="{ span: 7, offset: 1 }">
                <router-link class="link-login" to="/login">
                  <div style="margin-top: 10px; float: right">
                    <zr-icon icon="door-open"></zr-icon> 登录
                  </div>
                </router-link>
              </el-col>
              <el-col :lg="6" :sm="8" :xs="8">
                <router-link class="link-login" to="/">
                  <div style="margin-top: 10px; float: right">
                    <span class="fa fa-home"> 首页</span>
                  </div>
                </router-link>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  isPassword,
  isPhone,
  isEmail,
  isIdCard,
} from "zr-util/src/utils/comm/validate";
import { register } from "@api/recruit/user/acl";
import { messageDuration } from "../../config/settings";
import {encryptedData} from "@/utils/encrypt";

export default {
  username: "Register",
  directives: {
    focus: {
      inserted(el) {
        el.querySelector("input").focus();
      },
    },
  },
  data() {
    const validateusername = (rule, value, callback) => {
      if ("" == value) {
        callback(new Error("用户名不能为空"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!isPassword(value)) {
        callback(new Error("密码不能少于6位"));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (!isPhone(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validateEmail = (rule, value, callback) => {
      if (!isEmail(value)) {
        callback(new Error("请输入正确的邮箱地址"));
      } else {
        callback();
      }
    };
    const validateIdCard = (rule, value, callback) => {
      if (value && !isIdCard(value)) {
        callback(new Error("请输入正确的身份证号码"));
      } else {
        callback();
      }
    };
    return {
      fullscreenLoading: false,
      isGetphone: false,
      getPhoneIntval: null,
      phoneCode: "获取验证码",
      showRegister: false,
      nodeEnv: process.env.NODE_ENV,
      title: this.$baseTitle,
      form: {},
      registerRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入姓名" },
          { max: 20, trigger: "blur", message: "最多不能超过20个字" },
          { validator: validateusername, trigger: "blur" },
        ],
        phone: [
          { required: true, trigger: "blur", message: "请输入手机号码" },
          { validator: validatePhone, trigger: "blur" },
        ],
        email: [
          { required: true, trigger: "blur", message: "请输入邮箱地址" },
          { validator: validateEmail, trigger: "blur" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入密码" },
          { validator: validatePassword, trigger: "blur" },
        ],
        phoneCode: [
          { required: true, trigger: "blur", message: "请输入手机验证码" },
        ],
        idCardNum: [{ validator: validateIdCard, trigger: "blur" }],
      },
      loading: false,
      passwordType: "password",
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    this.getPhoneIntval = null;
    clearInterval(this.getPhoneIntval);
  },
  methods: {
    getPhoneCode() {
      this.isGetphone = true;
      let n = 60;
      this.getPhoneIntval = setInterval(() => {
        if (n > 0) {
          n--;
          this.phoneCode = "重新获取(" + n + "s)";
        } else {
          this.getPhoneIntval = null;
          clearInterval(this.getPhoneIntval);
          this.phoneCode = "获取验证码";
          this.isGetphone = false;
        }
      }, 1000);
    },

    /**
     * 密码校验（必须包含：字母、数字、特殊字符，长度 ≥ 10）
     * @param {string} password - 待校验密码
     * @returns {Object} 校验结果
     */
    checkPasswordStrength(password) {
      const result = {
        valid: false,
        errors: [],
        checks: {
          length: false,
          letter: false,
          number: false,
          special: false,
        },
      };
      // 检查长度
      if (!password || password.length < 10) {
        result.errors.push("密码长度至少10位");
      } else {
        result.checks.length = true;
      }
      // 检查字母（必须同时包含大小写）
      const hasLower = /[a-z]/.test(password);
      const hasUpper = /[A-Z]/.test(password);
      if (hasLower && hasUpper) {
        result.checks.letter = true;
      } else {
        result.errors.push("密码必须同时包含大小写字母");
      }
      // 检查数字
      if (/\d/.test(password)) {
        result.checks.number = true;
      } else {
        result.errors.push("密码必须包含数字");
      }
      // 检查特殊字符
      if (/[!@#$%^&*()_+\-=\[\]{}|;:,.<>?]/.test(password)) {
        result.checks.special = true;
      } else {
        result.errors.push("密码必须包含特殊字符");
      }
      // 判断是否通过
      result.valid = result.errors.length === 0;
      return result;
    },
    handleReister() {
      this.$refs["registerForm"].validate(async (valid) => {
        if (valid) {
          var res = this.checkPasswordStrength(this.form.password);
          if (!res.valid) {
            this.$message.error(
              "密码必须包含大小写字母 数字 特称字符,且长度不少于10位！"
            );
            return;
          }
          if (this.form.password !== this.form.confirmPassword) {
            this.$message.error("两次密码不一致");
            return;
          }
          let encryPassword = await encryptedData(this.form.password)
          const param = {
            name: this.form.username,
            mobile: this.form.phone,
            email: this.form.email,
            password: encryPassword,
            cardNumber: this.form.idCardNum,
          };
          this.fullscreenLoading = true;
          try {
            const res = await register(param);
            if (res.success) {
              //do
              this.$message.success({
                showClose: true,
                message: "注册成功！请登录",
                duration: messageDuration,
              });
              // 注册成功后跳转登录页面
               this.$router.push("/login");
            } else {
              this.$message.error(res.message);
            }
          } finally {
            this.fullscreenLoading = false;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.register-container {
  height: 100vh;
  background: url("~@/assets/login_images/bg_earth_sky.jpg") center center fixed
    no-repeat;
  background-size: cover;

  .title {
    font-size: 54px;
    font-weight: 500;
    color: rgba(14, 18, 26, 1);
  }

  .title-tips {
    margin-top: 29px;
    font-size: 26px;
    font-weight: 400;
    color: rgba(14, 18, 26, 1);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .register-btn {
    display: inherit;
    width: 120px;
    height: 50px;
    font-size: 18px;
    margin-top: 5px;
    border: 0;

    &:hover {
      opacity: 0.9;
    }
  }

  .register-form {
    position: relative;
    max-width: 100%;
    margin: calc((100vh - 499px) / 2) 10% 10%;
    overflow: hidden;

    .forget-password {
      width: 100%;
      margin-top: 40px;
      text-align: left;

      .forget-password {
        width: 129px;
        height: 19px;
        font-size: 20px;
        font-weight: 400;
        color: rgba(92, 102, 240, 1);
      }
    }

    .per-code {
      width: 100px;
      height: 36px;
      font-size: 20px;
      line-height: 36px;
      color: #fff;
      text-align: center;
      cursor: pointer;
      background: #bbc1ce;
    }

    .phone-code {
      width: 120px;
      height: 36px;
      font-size: 14px;
      color: #fff;
      border-radius: 3px;
    }
  }

  .tips {
    margin-bottom: 10px;
    font-size: $base-font-size-default;
    color: $base-color-white;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .title-container {
    position: relative;

    .title {
      margin: 0 auto 40px auto;
      font-size: 34px;
      font-weight: bold;
      color: $base-color-blue;
      text-align: center;
    }
  }

  .svg-container {
    position: absolute;
    top: 14px;
    left: 15px;
    z-index: $base-z-index;
    font-size: 16px;
    color: #d7dee3;
    cursor: pointer;
    user-select: none;
  }

  .show-pwd {
    position: absolute;
    top: 14px;
    right: 25px;
    font-size: 16px;
    color: $base-font-color;
    cursor: pointer;
    user-select: none;
  }

  ::v-deep {
    .el-form-item {
      padding-right: 0;
      margin: 20px 0;
      color: #454545;
      background: transparent;
      border: 1px solid transparent;
      border-radius: 2px;

      &__content {
        min-height: $base-input-height;
        line-height: $base-input-height;
      }

      &__error {
        position: absolute;
        top: 100%;
        left: 18px;
        font-size: $base-font-size-small;
        line-height: 18px;
        color: $base-color-red;
      }
    }

    .el-input {
      box-sizing: border-box;

      .el-input__count {
        .el-input__count-inner {
          background: transparent;
        }
      }

      .el-input__prefix {
        left: 15px;
        line-height: 56px;

        .svg-inline--fa {
          width: 20px;
        }
      }

      input {
        height: 58px;
        padding-left: 45px;
        font-size: $base-font-size-default;
        line-height: 58px;
        color: $base-font-color;
        background: #f6f4fc;
        border: 0;
        caret-color: $base-font-color;
      }
    }
  }
}

.link-login {
  color: $base-color-white;
  font-size: 20px;
}
</style>
